import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["navMenu", "heading", "children"];
import React from "react";
import SideNav, { NavContainer } from "./SideNav";
import Box from "../Box";
import Sheet from "../Sheet";
import DownIcon from "../Icons/DownIcon";
import RightIcon from '../Icons/RightIcon';

var ResponsiveNav = function ResponsiveNav(_ref) {
  var navMenu = _ref.navMenu,
      heading = _ref.heading,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(SideNav, props, /*#__PURE__*/React.createElement(NavContainer, null, /*#__PURE__*/React.cloneElement(navMenu, {
    variant: "side"
  })), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Sheet, {
    target: function target(_ref2) {
      var ref = _ref2.ref,
          setHidden = _ref2.setHidden,
          isHidden = _ref2.isHidden;
      return /*#__PURE__*/React.createElement(Box, {
        as: "button",
        display: ["block", "block", "none"],
        ref: ref,
        onClick: function onClick() {
          return setHidden(!isHidden);
        }
      }, /*#__PURE__*/React.cloneElement(heading, {
        children: /*#__PURE__*/React.createElement(React.Fragment, null, heading.props.children, " ", /*#__PURE__*/React.createElement(DownIcon, {
          display: ["none", "inline"],
          width: "0.6em",
          height: "0.6em"
        }), /*#__PURE__*/React.createElement(RightIcon, {
          display: ["inline", "none"],
          width: "0.65em",
          height: "0.65em"
        })),
        sa: "spacer40",
        sb: "spacer30"
      }));
    },
    smContent: function smContent() {
      return /*#__PURE__*/React.cloneElement(navMenu, {
        variant: "mobile"
      });
    },
    content: function content() {
      return /*#__PURE__*/React.cloneElement(navMenu, {
        variant: "popover",
        width: "270px"
      });
    }
  }), /*#__PURE__*/React.cloneElement(heading, {
    display: ["none", "none", "block"],
    sa: "spacer40",
    sb: "spacer30"
  }), children));
};

export default ResponsiveNav;